// frontend/src/components/games/tetris/TetrisNextPreview.tsx

import { TetrominoType, TETROMINO_SHAPES, TETROMINO_COLORS } from './tetrominoes';

interface TetrisNextPreviewProps {
  type: TetrominoType;
}

export function TetrisNextPreview({ type }: TetrisNextPreviewProps) {
  const shape = TETROMINO_SHAPES[type];
  const size = shape.length;

  return (
    <div className="tetris-next-preview">
      <div className="tetris-next-label">Sıradaki</div>
      <div
        className="tetris-next-grid"
        style={{ gridTemplateColumns: `repeat(${size}, 1fr)`, gridTemplateRows: `repeat(${size}, 1fr)` }}
      >
        {shape.map((row, r) =>
          row.map((cell, c) => (
            <div
              key={`${r}-${c}`}
              className={`tetris-next-cell ${cell ? 'filled' : ''}`}
              style={cell ? { background: TETROMINO_COLORS[type] } : undefined}
            />
          ))
        )}
      </div>
    </div>
  );
}
